/* istanbul ignore file */
import React from 'react';

export function ListingRooms({
    bathrooms,
    bedrooms,
    className,
    sleeps
}) {
    return (
        <span className={`listing-rooms ${className || ''}`}>
            {`${bedrooms} · ${bathrooms} · ${sleeps}`}
        </span>
    );
}

export default ListingRooms;


// WEBPACK FOOTER //
// ./src/universal/tripboard/listing/listing-rooms.js